import {
    ADD_IMAGE, DELETE_IMAGE, GALLERY_ERROR, LOAD_GALLERY
} from '../actions/types';

const initialState = {
    image: null,
    images: [],
    loading: true,
    error: {}
}


export default function foo(state = initialState, action) {
    const { type, payload } = action;

    switch(type) {
        case GALLERY_ERROR:
            return{
                ...state,
                error: payload,
                loading: false,
            };
        case LOAD_GALLERY:
            return {
                ...state,
                images: payload,
                loading: false,
            };
        case ADD_IMAGE:
            return {
                ...state,
                images: [payload, ...state.images],
                loading: false
            };
        case DELETE_IMAGE:
            return {
                ...state,
                images: state.images.filter(image => image._id !== payload),
                loading: false
            };
        default:
            return state;
    }
}

